import { Outlet } from "react-router-dom";
import { useState, useEffect } from "react";
import {
  ThemeProvider,
  CssBaseline,
  Drawer,
  useMediaQuery,
  Box,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import "./AppLayout.scss"; // For smooth transitions on larger screens
import NavBar from "./NavBar";
import LeftSidebar from "./LeftSidebar";
import Footer from "./Footer";
import NavigateAuth from "../components/others/NavigateAuth";
import { lightTheme, darkTheme } from "../mui/Theme"; // Import themes

function AppLayout() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [mode, setMode] = useState(
    localStorage.getItem("themeMode") || "light"
  );
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm")); // Detect small screens

  useEffect(() => {
    if (!isSmallScreen) {
      setIsSidebarOpen(true);
    }
  }, [isSmallScreen]);

  useEffect(() => {
    localStorage.setItem("themeMode", mode);
    document.body.className = mode; // Optional: add dark/light class to body
  }, [mode]);

  const toggleTheme = () => {
    setMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
  };

  return (
    <ThemeProvider theme={mode === "light" ? lightTheme : darkTheme}>
      <CssBaseline />
      <div
        className={`main ${isSidebarOpen ? "sidebar-open" : "sidebar-closed"}`}
      >
        {/* Use MUI Drawer for small screens */}
        {isSmallScreen ? (
          <Drawer
            anchor="left"
            open={isSidebarOpen}
            onClose={() => setIsSidebarOpen(false)}
            ModalProps={{ keepMounted: true }} // Keeps the component in the DOM for smoother transitions
            sx={{
              height: "100%",
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                width: 240,
                //padding: 2,
                paddingRight: 0,
                bgcolor: "#374151",
                height: "100%",
                overflow: "hidden",
              }}
            >
              {/* Adjust the width of the drawer */}
              <LeftSidebar />
            </Box>
          </Drawer>
        ) : (
          // Regular Sidebar for larger screens with smooth transitions
          <div
            className={`leftContainer  ${
              isSidebarOpen ? "sidebar-open" : "sidebar-closed"
            }`}
          >
            <LeftSidebar />
          </div>
        )}

        {/* Main Content Area */}
        <div className="mainContainer">
          <NavBar
            setIsSidebarOpen={setIsSidebarOpen}
            isSidebarOpen={isSidebarOpen}
            toggleTheme={toggleTheme}
            mode={mode}
          />
          <div className="contentContainer p-0 md:p-5">
            <NavigateAuth>
              <Outlet />
            </NavigateAuth>
          </div>
          <Footer />
        </div>
      </div>
    </ThemeProvider>
  );
}

export default AppLayout;
